import { TasksKanbanGrouppingTypeEnum } from '../enums';
import { TaskViewSettings } from '../types';
import { GetTaskListRequestSortModel } from './GetTaskListRequestSortModel';
import { PageRequestModel } from './PageRequestModel';

/**
 * * Модель запроса на получение сгруппированных задач
 */
export class GroupedTaskRequestModel {
  /**Группировка */
  GrouppedBy!: TasksKanbanGrouppingTypeEnum;
  /**ID очереди задач */
  QueueTaskId!: string;
  /**ID параметра группировки */
  ParameterId?: number;
  /**Данные страниц */
  Page?: PageRequestModel;
  /**Кол-во задач в колонке */
  ColumnTakeCount!: number;
  /**Настройки отображения */
  ViewSettings!: TaskViewSettings;
  /**Строка поиска */
  Search?: string;
  /**Настройки сортировки */
  Sort!: GetTaskListRequestSortModel;

  constructor(obj?: Partial<GroupedTaskRequestModel>) {
    Object.assign(this, obj);
  }
}
